<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        インフォメーション
      </div>
      <div class="card-body">
        <!-- <p class="h2">インフォメーション</p> -->
        <p> 最新情報を表示します。</p>
        <hr class="my-3">
        <dl class="filelist">
          <dt style="" class="">2025.10.29</dt>
          <dd style="" class="">
            A's 3D Player iOS版 3.1.1（<A HREF="https://itunes.apple.com/jp/app/as-3d-player/id1416432963#?platform=iphone" target="_blank">詳細はこちら</A>）<br>
            A's 3D Player Android版 2.1.2（<A HREF="https://play.google.com/store/apps/details?id=co.jp.cpu.as3dplayer" target="_blank">詳細はこちら</A>）
          </dd>
        </dl>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        A's 3D Player マニュアル
      </div>
      <div class="card-body">
       <div class="container-fluid">
           <div style="float: left;">
              <ul class="list-unstyled" style="width: 330px;">
                <li>3DPlayer使い方ガイド（お施主様向け）（<A HREF="https://info.cpucloud.jp/3DPlayer_Guide.pdf" target="_blank">PDF</A>）</li>
              </ul>
              <a href="https://info.cpucloud.jp/3DPlayer_Guide.pdf" target="_blank"><b-img thumbnail fluid src="static/img/manual.jpg" alt="Thumbnail" /></a>
          </div>
          <div style="float: left;">
            <div>
             <ul class="list-unstyled" style="width: 330px;">
              <li>チラシ（お施主様向け）（<A HREF="https://info.cpucloud.jp/3DPlayer_Leaflet.pdf" target="_blank">PDF</A>）</li>
             </ul>
             <a href="https://info.cpucloud.jp/3DPlayer_Leaflet.pdf" target="_blank"><b-img thumbnail fluid src="static/img/leaflet.jpg" alt="Thumbnail" /></a>
            </div>
          </div>
          <div style="float: left;">
            <div>
             <ul class="list-unstyled" style="width: 330px;">
              <li>3D Player連携編（<A HREF="https://www.cpu-net.co.jp/cad/user/data/2025/as_3dplayer.pdf" target="_blank">PDF</A>）</li>
             </ul>
             <a href="https://www.cpu-net.co.jp/cad/user/data/2025/as_3dplayer.pdf" target="_blank"><b-img thumbnail fluid src="static/img/as.jpg" alt="Thumbnail" /></a>
            </div>
          </div>
       </div>
      </div>
    </div>
    <!-- <div class="card">
      <div class="card-header">
        A's 3D Player デモ・操作動画
      </div>
      <div class="card-body">
        <ul class="list-unstyled">
          <li>
            <div class="embed-responsive embed-responsive-16by9" style="max-width :600px; margin-top:0px;">
              <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/videoseries?list=PLuVwGRGZJLVlnSSlg0gjvPlTBzBCJvLKi&rel=0" frameborder="0" allowfullscreen></iframe>
            </div>
          </li>
          <li><A HREF="https://youtu.be/tMJ-iTDpCfY" target="_blank">プロモーション（2分9秒）</A></li>
          <li style="margin-top:10px;">01 <A HREF="https://youtu.be/HcXo_ikZyTs" target="_blank">起動、QRコード読込み（1分5秒）</A></li>
          <li>02 <A HREF="https://youtu.be/ppMrWkASI44" target="_blank">視点切替え、ウォークスルー（1分8秒）</A></li>
          <li>03 <A HREF="https://youtu.be/dQYjgKZXtPo" target="_blank">建物表現切替え（38秒）</A></li>
          <li>04 <A HREF="https://youtu.be/dEZVJo3sTDY" target="_blank">太陽光シミュレーション（40秒）</A></li>
          <li>05 <A HREF="https://youtu.be/EgC8XCqoDoE" target="_blank">画像保存、設定（56秒）</A></li>
          <li>06 <A HREF="https://youtu.be/HuzFGqqDoyU" target="_blank">出力、管理画面（建築業者向け）（1分25秒）</A></li>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'typography'
}
</script>

<style scoped>
a:link { color:#23527c; }
a:visited { color: #23527c; }
.card {
    color: #333333;
}
dl
,dt
,dd
{
    margin: 0; padding: 0;
}

.filelist dt,
.filelist dd
{
    overflow: hidden;
    white-space: normal;
    float: left;
}

.filelist
{
    width: 800px;
}

.filelist dt
{
    width: 150px;
}

.filelist dd
{
    width: 350px;
}

@media screen and (min-width: 632px) and (max-width: 833px)
{
    .filelist
    {
        width: 600px;
    }

    .filelist dt
    {
        width: 350px;
    }

    .filelist dd
    {
        width: 345px;
    }
}

@media screen and (max-width: 631px)
{
    .filelist {width: 100%;}
    .filelist dt
    ,.filelist dd
    {
        width: 95%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue